import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DictionaryItem } from '../../../interfaces/dictionary-item.interface';
import { PredefinedValue } from '../../../interfaces/predefined-value.interface';
import { ReferenceField } from '../../../interfaces/reference-field.interface';
import { DataSourceValueField } from '../data-source/data-source-field';
import { DataSourceOptions } from '../data-source/data-source-options';

@Component({
  selector: 'forms-dropdown',
  templateUrl: './dropdown.component.html',
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true,
    },
  ],
})
export class DropdownComponent extends DataSourceValueField {
  protected optionsLimit = 15;
  protected filterString: string = '';

  private filterResult: FilterResult = {
    filterValue: '',
    values: [],
  };

  public shouldNotShowAutocomplete(): boolean {
    const result = this.formField && this.formField.values && this.formField.values.length < this.optionsLimit;
    return result;
  }

  public getDropdownValues(): DataSourceOptions {
    if (!this.filterString || !this.filterString.trim()) {
      return this.formField.values;
    }

    const filterValue = this.filterString.trim().toLocaleLowerCase();

    if (this.filterResult.filterValue === filterValue) {
      return this.filterResult.values;
    }

    this.filterResult = {
      filterValue: filterValue,
      values: this.filterValues(filterValue),
    };

    return this.filterResult.values;
  }

  private filterValues(value: string): DataSourceOptions {
    switch (this.formField.dataSource) {
      case 'dataView':
        return (this.formField.values as ReferenceField[]).filter((option) => this.optionFieldContains(option, 'dataViewColumn', value));
      case 'dictionary':
        return (this.formField.values as DictionaryItem[]).filter((option) => this.optionFieldContains(option, 'name', value));
      case 'predefined':
        return (this.formField.values as PredefinedValue[]).filter((option) => this.optionFieldContains(option, 'value', value));
    }
  }

  private optionFieldContains(option: ReferenceField | DictionaryItem | PredefinedValue, fieldName: string, value: string): boolean {
    if (!option[fieldName]) return false;
    return option[fieldName].toLocaleLowerCase().includes(value);
  }
}

interface FilterResult {
  filterValue: string;
  values: DataSourceOptions;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/dropdown/dropdown.component.ts